import type { RealtimeChannelStatus } from '@/stores/realtime-sync-diagnostics-store';
import { useRealtimeSyncDiagnosticsStore } from '@/stores/realtime-sync-diagnostics-store';

export function updateChannelStatus(
  key: string,
  status: RealtimeChannelStatus,
  options?: { error?: string },
): void {
  useRealtimeSyncDiagnosticsStore.getState().setChannelStatus(key, status, options);
}

export function clearChannelStatuses(): void {
  useRealtimeSyncDiagnosticsStore.getState().clearChannels();
}
